<template>
  <router-view />
</template>

<script>
export default {
  name: "stats",
  components: {},
};
</script>
